import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FileIntegrationViewModel } from '../../file-integration-detail/generic/models/file-integration-view-model';

@Component({
	selector: 'eif-filename-cell',
	changeDetection: ChangeDetectionStrategy.OnPush,
	template: `
		<div>
			@if (showDetails) {
				<div
					[eifTooltip]="tooltip"
					[disableTooltip]="!tooltip"
					class="truncate">
					<a
						[routerLink]="detailLink"
						(click)="onLinkClick()">
						{{ displayText }}
					</a>
				</div>
			} @else {
				<p
					class="truncate is-bold"
					[eifTooltip]="tooltip"
					[disableTooltip]="!tooltip">
					{{ displayText }}
				</p>
			}
		</div>
	`,
	standalone: false,
})
export class FilenameCellComponent {
	@Input() row: FileIntegrationViewModel;
	@Input() showDetails: boolean = false;
	@Input() detailLink: string | null = null;
	@Input() displayText: string = '';
	@Input() tooltip: string = '';
	@Input() linkClickHandler?: () => void;

	onLinkClick(): void {
		if (this.linkClickHandler) {
			this.linkClickHandler();
		}
	}
}
